/**
 * Costanti globali dell'applicazione Bolletto.
 * Centralizza URL, asset, opzioni di selezione.
 */

/** Base URL per tutte le chiamate API */
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Logo Energy.Lab (GIF animata) */
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_bill-compare-4/artifacts/1n4zuw4u_energyLab.gif";

/** Logo Bolletto (PNG) */
export const BOLLETTO_LOGO_URL = "https://customer-assets.emergentagent.com/job_bill-compare-4/artifacts/pjfx4a77_BOLLETTO.png";

/** Mascotte Energino - analisi positiva (risparmio) */
export const ENERGINO_HAPPY = "https://customer-assets.emergentagent.com/job_bill-compare-4/artifacts/bkr51z91_MASCOTTE%20ENERGINO%20ANALISI%20POSITIVA.png";

/** Mascotte Energino - analisi negativa (rincaro) */
export const ENERGINO_SAD = "https://customer-assets.emergentagent.com/job_bill-compare-4/artifacts/02nbpd7m_MASCOTTE%20ENERGINO%20ANALISI%20NEGATIVA.png";

/**
 * Opzioni tipologia cliente.
 * Ogni entry ha: value (chiave DB), label (testo UI), icon (componente Lucide).
 * Le icone vengono importate dal consumatore per evitare dipendenze circolari.
 */
export const CUSTOMER_TYPES = [
  { value: 'domestico', label: 'Domestico', iconName: 'Users' },
  { value: 'condominio', label: 'Condominio', iconName: 'Building' },
  { value: 'business', label: 'Business', iconName: 'Briefcase' },
];
